import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavigationModern from './components/NavigationModern';
import FooterModern from './components/FooterModern';
import LoginModern from './components/LoginModern';
import SignupModern from './components/SignupModern';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import HomeModern from './pages/HomeModern';
import LawyerListing from './pages/LawyerListing';
import LawyerProfileModern from './pages/LawyerProfileModern';
import LawyerProfileSetup from './pages/LawyerProfileSetup';
import BookingModern from './pages/BookingModern';
import ContactModern from './pages/ContactModern';
import AdminDashboard from './pages/AdminDashboard';
import CaseStudiesPublic from './pages/CaseStudiesPublic';
import CaseStudies from './pages/CaseStudies';
import About from './pages/About';
import Blog from './pages/Blog';
import Team from './pages/Team';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('auth_token');
    const userData = localStorage.getItem('user_data');
    
    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('auth_token', token);
    localStorage.setItem('user_data', JSON.stringify(userData));
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-secondary-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center animate-pulse">
            <span className="text-white text-xl">⚖️</span>
          </div>
          <div className="w-8 h-8 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
      <NavigationModern isAuthenticated={isAuthenticated} user={user} onLogout={handleLogout} />
      <main className="flex-1 pt-16">
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomeModern />} />
        <Route path="/lawyers" element={<LawyerListing user={user} />} />
        <Route path="/lawyer/:id" element={<LawyerProfileModern />} />
        <Route path="/booking" element={<BookingModern user={user} />} />
        <Route path="/contact" element={<ContactModern />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/team" element={<Team />} />
        <Route path="/case-studies" element={<CaseStudiesPublic />} />
        <Route path="/case-study/:id" element={<CaseStudiesPublic />} />

        {/* Auth Routes */}
        <Route 
          path="/login" 
          element={<LoginModern onLogin={handleLogin} />}
        />
        <Route 
          path="/signup" 
          element={<SignupModern onLogin={handleLogin} />}
        />

        {/* Protected Routes */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user}>
              <Dashboard user={user} onLogout={handleLogout} />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/lawyer-profile-setup" 
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated} user={user}>
              <LawyerProfileSetup user={user} />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/admin" 
          element={
            <AdminRoute isAuthenticated={isAuthenticated} user={user}>
              <AdminDashboard />
            </AdminRoute>
          }
        />
      </Routes>
      </main>
      <FooterModern />
      </div>
    </Router>
  );
}

export default App;
